<template>
  <div>
    <div id="biblioContent" class="" >

      <div style="margin-bottom: 15px" v-if="isFullScreen">
        <button v-if="type !== 'preview'" class="btn btn-xs btn-info" @click="showModalAddKeyword">Add Keyword</button>
        <button v-if="type !== 'preview'" class="btn btn-xs btn-info" @click="undo"><i class="fa fa-reply"></i> Undo</button>
        <button v-if="type !== 'preview'" class="btn btn-xs btn-info" @click="redo"><i class="fa fa-mail-forward"></i> Redo</button>
        <button v-if="type !== 'preview'" class="btn btn-xs btn-info" @click="preview">Preview</button>
        <vue-ladda v-if="type !== 'preview'" class="btn btn-xs btn-info" @click="pdf" :loading="submit.loading" :data-style="submit.dataStyle">PDF</vue-ladda>
        <button v-if="type !== 'preview'" class="btn btn-xs btn-info" @click="exportImage">Image</button>
        <button v-if="type !== 'preview'" class="btn btn-xs btn-info" @click="showModalExportJson">Export as JSON</button>
        <button v-if="type !== 'preview'" class="btn btn-xs btn-info" @click="showModalImportJson">Import as JSON</button>
        <button v-if="type !== 'preview' && !$user.isOrange() && !$user.isSe()" class="btn btn-xs btn-info" @click="getAllTechnoLockIn" title="Automated extraction of tech/sci problems contained in abstracts (Beta)"><i class="fa fa-share-square"></i> Extract</button>
        <span class="" style="float: right"><button class="btn btn-xs btn-info" @click="fullScreen"><i id="iconFullScreen" class="glyphicon glyphicon-resize-full"></i></button></span>
        <span class="clearfix"></span>
      </div>

      <div v-if="biblioContent === '{}' || biblioContent === null" style="height: 300px; padding-top: 50px" class="text-center">
        <div style="font-size: 16px">
          <h4 class="m-b-xs">Empty biblio</h4>
          <div class="text-left" style="display: inline-block;margin-top: 15px">
            <h5>Save, Structure and Share your Tech landscaping here</h5>
            <ul style="list-style: inside;margin-top: 10px">
              <li>
                <router-link v-if="project" :to="{name: 'Search', params:{project_id: project.id}}">
                  Explore
                </router-link> and use ‘Add to Biblio’ buttons</li>
              <li>Import and export</li>
              <li>Use to communicate and share</li>
            </ul>
          </div>

          <div class="clearfix" style="margin-top: 15px">
            <a href="https://www.youtube.com/watch?v=Piv0KET7rUA" class="btn btn-info btn-sm btn-outline"  target="_blank">
              <i class="fab fa-youtube"></i> 2 mn tutorial
            </a>
          </div>
        </div>
      </div>
      <biblio-go-js ref="biblio" id="biblioGoJS" :class="{hide: biblioContent === '{}' || biblioContent === null}"
                    :content="biblioContent"
                    :modal="modal"
                    :modalWiki="modalWiki"
                    :modalDocuments="modalDocuments"
                    :menu="menu"
                    :editable="type !== 'preview'"
                    style="width:100%; height:100%"
                    @updateBiblioContent="updateBiblioContent"
                    :style="isFullScreen ? 'height: 95%' : (typeof height === 'undefined' ? 'height: 400px' : 'height: '+ height+'px')"/>
      <div :style="this.menu.style" id="contextMenu">
        <div class="dropup" >
          <ul class="dropdown-menu show" aria-labelledby="dropdownCopy" style="min-width: 100%">
            <li v-for="(action, key) in menu.actions" :key="key" v-on:click="action.command"><a href="#" >{{action.text}} ({{action.shortened}})</a></li>
          </ul>
        </div>
      </div>
    </div>

    <div id="boxModal" class="modal fade hmodal-info" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="color-line" style="display: block;"></div>
          <div class="modal-header">
            <div class="span-12 text-right"><a class="closebox" data-dismiss="modal" aria-hidden="true"><i class="fa fa-times"></i></a></div>
            <h4 class="modal-title  text-capitalize">Edit Box</h4>
            <span class="">Personalize color, icon, name, comment or add files </span>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="form-group">
                <label class="control-label col-sm-3" for="boxName">Box Name:</label>
                <div class="col-sm-9 m-b-xs">
                  <input type="text" name="name" id="boxName" class="form-control " v-model="modal.name">
                </div>
              </div>

              <div class="form-group">
                <label class="control-label  col-sm-3" for="boxColor">Box Color :</label>
                <div class="col-sm-9 m-b-xs">
                  <select name="boxColor" id="boxColor" >
                    <option value="#7bd148">Green</option>
                    <option value="#5484ed">Bold blue</option>
                    <option value="#a4bdfc">Blue</option>
                    <option value="#46d6db">Turquoise</option>
                    <option value="#7ae7bf">Light green</option>
                    <option value="#51b749">Bold green</option>
                    <option value="#fbd75b">Yellow</option>
                    <option value="#ff887c">Red</option>
                    <option value="#dc2127">Bold red</option>
                    <option value="#dbadff">Purple</option>
                    <option value="#34495e">Default Color</option>
                    <option value="#e1e1e1">Gray</option>
                    <option value="#bbbbbb" selected>Middle gray</option>
                    <option value="#888888">Dark gray</option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-3" for="boxColor" >Box Icon :</label>
                <div class="col-sm-9 m-b">
                  <!-- <button class="btn  btn-info btn-outline" role="iconpicker" id="iconSelected"></button>-->
                  <button class="btn  btn-info btn-outline" role="iconpicker" id="iconSelected1"></button>
                  <button class="btn  btn-info btn-outline" role="iconpicker" id="iconSelected2"></button>
                 <!-- <div role="iconpicker" id="iconSelected"></div> -->
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-3" for="boxSearchUrl">Search URL:</label>
                <div class="col-sm-9 m-b-xs">
                  <input type="text" id="boxSearchUrl" class="form-control " v-model="modal.searchUrl">
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-3" for="boxComments">Comments:</label>
                <div class="col-sm-9 m-b-xs">
                  <textarea name="name" id="boxComments" class="form-control col-sm-9" rows="4" v-model="modal.comment"></textarea>
                </div>
              </div>

              <div class="form-group"  v-bind:class="{'has-error' : modal.errorFiles, 'has-info' : modal.errorFiles === false}">
                <label for="files" class="col-sm-3 control-label text-left m-t">Add external file
                  <i class="fa fa-info-circle text-info" data-toggle="popover" :data-content="'Internal Document /Report /Product info /Patent /Other'" style="cursor: pointer;"></i>
                </label>
                <div class="col-sm-9 m-b-xs m-t">
                  <div class="row text-center">
                    <upload-file id="files" :files="modal.files" :type="'biblio_doc'" :uploadFiles="modal.uploadFiles" :removeFile="removeFile" />
                    <span v-if="modal.errorFiles" class="help-block text-danger">{{ modal.errorFiles }}</span>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-default" data-dismiss="modal" aria-hidden="true">Close</button>
            <button v-if="type !== 'preview'" class="btn btn-info" id="boxSave">Save changes</button>
          </div>
        </div>
      </div>
    </div>
    <div id="modalWiki" class="modal fade hmodal-info" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content" v-if="modalWiki.description">
          <div class="color-line" style="display: block;"></div>
          <div class="modal-header text-capitalize" id="modalWikiTitle" v-if="modalWiki">
            <div class="span-12 text-right"><a class="closebox" data-dismiss="modal" aria-hidden="true"><i class="fa fa-times"></i></a></div>
            <h4 class="modal-title  text-capitalize">{{modalWiki.title}}</h4>
            <span class="font-bold">Wikipedia article</span>
          </div>
          <div class="modal-body">
            <div class="">
              <div v-html="modalWiki.description"></div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="col-sm-12 text-center" style="margin-top: 15px">
              <div class="col-sm-6 text-left">
                <a class="btn btn-info btn-outline btn-md" id="modalWikiRemove" :data-id="modalWiki.title"><i class="fa fa-trash"></i> Remove</a>
              </div>
              <div class="col-sm-6 text-right">
                <button class="btn btn-info btn-outline btn-md" data-dismiss="modal" aria-hidden="true"> <i class="fa fa-close"></i> Close</button>
                <a v-if="modalWiki.url" :href="modalWikiUrl" target="_blank" class="btn btn-info btn-md"><i class="fa fa-eye"></i> View full article</a>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-content" v-else>
          <div class="modal-header">
            <div class="span-12 text-right"><a class="closebox" data-dismiss="modal" aria-hidden="true"><i class="fa fa-times"></i></a></div>
            <h3>Wikipedia article</h3>
          </div>
          <div class="modal-body">
            <div class="text-center">
              <h2>No wiki definition in this box</h2>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-info btn-outline btn-md" data-dismiss="modal" aria-hidden="true"> <i class="fa fa-close"></i> Close</button>
          </div>
        </div>
      </div>
    </div>
    <div id="modalDocuments" class="modal fade hmodal-info" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="color-line" style="display: block;"></div>
          <div class="modal-header">
            <div class="span-12 text-right"><a class="closebox" data-dismiss="modal" aria-hidden="true"><i class="fa fa-times"></i></a></div>
            <h4 class="modal-title  text-capitalize" id="modalDocumentsTile">Documents: <span style="font-weight: bold">{{modalDocuments.title}}</span></h4>
          </div>
          <div class="modal-body">

              <div class="row">
                <div class="hpanel">
                  <div class="hpanel">

                    <ul class="nav nav-tabs m-b">
                      <li  :class="{'active' : !modalDocuments.type ||  modalDocuments.type === 'scienceDoc'}"><a data-toggle="tab" href="#scienceDocsTab"><i class="fa fa-files-o" aria-hidden="true"></i> Science</a></li>
                      <li :class="{'active' : modalDocuments.type &&  modalDocuments.type === 'patentDoc'}" ><a data-toggle="tab" href="#patentDocsTab"><i class="fa fa-file-powerpoint-o" aria-hidden="true"></i> Patents</a></li>
                      <li :class="{'active' : modalDocuments.type &&  modalDocuments.type === 'newsDoc'}" ><a data-toggle="tab" href="#newsDocsTab"><i class="fa fa-newspaper-o" aria-hidden="true"></i> News</a></li>
                      <li :class="{'active' : modalDocuments.type &&  modalDocuments.type === 'externalFile'}"><a data-toggle="tab" href="#externalFilesTab"><i class="fa fa-download" aria-hidden="true"></i> External Files</a></li>
                    </ul>
                    <div class="tab-content">
                      <div id="scienceDocsTab" class="tab-pane" :class="{'active' : !modalDocuments.type ||  modalDocuments.type === 'scienceDoc'}">
                        <div class="" v-if="nbScienceDoc() !== 0">
                          <div v-for="(document, key) in modalDocuments.documents" :key="key" class="well-lg well" v-if="!document.type || (document.type !== 'patents' && document.type !== 'company' && document.type !== 'news')" >
                            <div class="row">
                              <div class="col-sm-12">
                                <label class="col-sm-2">Title</label>
                                <span class="col-sm-10" v-html="document.title"></span>
                              </div>
                              <div class="col-sm-12">
                                <label class="col-sm-2">Authors</label>
                                <div v-if="document.authorsDetails" class="col-sm-10">
                                  <document-authors  v-model="document.authorsDetails" :listId="listId" :companyAuthors="companyAuthors"
                                                     :query="modalDocuments.title" :docId="document.id" :isReadOnly="type === 'preview'"> </document-authors>
                                </div>

                                <span class="col-sm-10" v-else>{{document.authors}}</span>
                              </div>
                              <div class="col-sm-12">
                                <label class="col-sm-2">Source</label>
                                <span class="col-sm-10">{{document.source}} <template v-if="document.dt">,{{document.dt}}</template></span>
                              </div>

                              <div class="col-sm-12" v-if="document.added">
                                <label class="col-sm-2">Added to project</label>
                                <span class="col-sm-10" v-if="document.added && document.added.date">{{document.added.date | moment('ll')}}</span>
                                <span v-else-if="document.added" class="col-sm-10" >{{document.added | moment('ll')}}</span>
                              </div>
                              <div v-if="!$user.isOrange() && !$user.isSe()" class="col-sm-12">
                                <label class="col-sm-2">Tech/sci problem(s)</label>
                                <span class="col-sm-10" v-if="document.technoLockIn" style="white-space: pre-line;">{{document.technoLockIn.replace('\n\n', '')}}</span>
                                <span v-else class="col-sm-10" > <a class="btn btn-info btn-outline btn-md verrouTechnoLockIn" :data-id="document.id" :data-type="document.type ? document.type : 'author'" ><i class="fa fa-share-square"></i> Extract</a> </span>
                              </div>
                              <div class="col-sm-12">
                                <label class="col-sm-2" style="">Abstract</label>
                                <div style="" class="col-sm-12">
                                  <summernote :id="'editAbstract-' + document.id" style="" v-model="document.abstract" :airMode="false"></summernote>
                                </div>
                              </div>
                              <div class="col-sm-12 text-center" style="margin-top: 15px">
                                <div class="col-sm-3">
                                  <a class="btn btn-info btn-outline btn-md" target="_blank" :href="document.link ? document.link : '/search/reference/' + document.id"><i class="fa fa-eye"></i> View document</a>
                                </div>
                                <div class="col-sm-2" v-if="type !== 'preview'">
                                  <a class="btn btn-info btn-outline btn-md modalDocumentRemove" id="modalDocumentRemove" :data-id="document.id"><i class="fa fa-trash"></i> Remove</a>
                                </div>
                                <div class="col-sm-3" v-if="type !== 'preview'">
                                  <a class="btn btn-info btn-outline btn-md modalDocumentMove" :data-id="document.id" :data-type="document.type ? document.type : 'author'" ><i class="fa fa-exchange-alt"></i> Move To Patents</a>
                                </div>
                                <div class="col-sm-2" v-if="type !== 'preview'">
                                  <div class="dropup" >
                                    <button class="btn btn-info btn-outline btn-md dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                                      <i class="fa fa-copy"></i>
                                      Copy To
                                      <span class="caret"></span>
                                    </button>
                                    <ul class="dropdown-menu dropdownCopy" aria-labelledby="dropdownCopy" style="min-width: 100%">
                                      <li v-for="(box, boxKey) in modalDocuments.box" :key="boxKey" style="width: 100%; padding: 5px 5px"><a href="#" class="modalDocumentCopy" :data-id="document.id" :data-targetBox="box.key">{{box.name}}</a></li>
                                    </ul>
                                  </div>
                                </div>
                                <div class="col-sm-2" v-if="type !== 'preview'">
                                  <button class="btn btn-info btn-outline btn-md modalDocumentSave" id="modalDocumentSave" :data-id="document.id"><i class="fa fa-save"></i> Save</button>
                                </div>
                              </div>

                            </div>
                          </div>
                          <div class="well-lg well">
                            <div style="margin-top: 10px" v-for="(document, key) in modalDocuments.documents" :key="key" v-if="(!document.type || (document.type !== 'patents' && document.type !== 'company' && document.type !== 'news')) && document.cite"> **{{document.cite}}</div>
                          </div>

                        </div>
                        <div v-else class="text-center">
                          <h2>No documents in this box</h2>
                        </div>
                      </div>
                      <div id="patentDocsTab" class="tab-pane" :class="{'active' : modalDocuments.type &&  modalDocuments.type === 'patentDoc'}">
                        <div class="" v-if="nbPatentDoc() !== 0">
                          <div v-for="(document, key) in modalDocuments.documents" :key="key" class="well-lg well" v-if="document.type && (document.type === 'patents' || document.type === 'company')" >
                            <div class="row">
                              <div class="col-sm-12">
                                <label class="col-sm-2">Title</label>
                                <span class="col-sm-10" v-html="document.title"></span>
                              </div>
                              <div class="col-sm-12">
                                <label class="col-sm-2">Authors</label>
                                <div v-if="document.authorsDetails" class="col-sm-10">
                                  <document-authors  v-model="document.authorsDetails" :listId="listId" :companyAuthors="companyAuthors"
                                                     :query="modalDocuments.title" :docId="document.id" :isReadOnly="type === 'preview'"> </document-authors>
                                </div>

                                <span class="col-sm-10" v-else>{{document.authors}}</span>
                              </div>

                              <div class="col-sm-12" v-if="document.authorsDetails && extractAffiliationName(document.authorsDetails)">
                                <label class="col-sm-2">Affiliation</label>
                                <div class="col-sm-10">
                                  <span>
                                      {{ extractAffiliationName(document.authorsDetails) }}
                                  </span>
                                </div>
                              </div>

                              <div class="col-sm-12">
                                <label class="col-sm-2">Source</label>
                                <span class="col-sm-10">{{document.source}} <template v-if="document.dt">,{{document.dt}}</template></span>
                              </div>

                              <div class="col-sm-12" v-if="document.added">
                                <label class="col-sm-2">Added to project</label>
                                <span class="col-sm-10" v-if="document.added && document.added.date">{{document.added.date | moment('ll')}}</span>
                                <span v-else-if="document.added" class="col-sm-10" >{{document.added | moment('ll')}}</span>
                              </div>

                              <div class="col-sm-12">
                                <label class="col-sm-2" style="">Abstract</label>
                                <div style="" class="col-sm-12">
                                  <summernote :id="'editAbstract-' + document.id" style="" v-model="document.abstract" :airMode="false"></summernote>
                                </div>
                              </div>
                              <div class="col-sm-12 text-center" style="margin-top: 15px">
                                <div class="col-sm-3">
                                  <a class="btn btn-info btn-outline btn-md" target="_blank" :href="document.link ? document.link : '/search/reference/' + document.id"><i class="fa fa-eye"></i> View document</a>
                                </div>
                                <div class="col-sm-2" v-if="type !== 'preview'">
                                  <a class="btn btn-info btn-outline btn-md modalDocumentRemove" :data-id="document.id"><i class="fa fa-trash"></i> Remove</a>
                                </div>
                                <div class="col-sm-3" v-if="type !== 'preview'">
                                  <a class="btn btn-info btn-outline btn-md modalDocumentMove" :data-id="document.id" :data-type="document.type ? document.type : 'author'" ><i class="fa fa-exchange-alt"></i> Move To Science</a>
                                </div>
                                <div class="col-sm-2" v-if="type !== 'preview'">
                                  <div class="dropup" >
                                    <button class="btn btn-info btn-outline btn-md dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                                      <i class="fa fa-copy"></i>
                                      Copy To
                                      <span class="caret"></span>
                                    </button>
                                    <ul class="dropdown-menu dropdownCopy" aria-labelledby="dropdownCopy" style="min-width: 100%">
                                      <li v-for="(box, boxKey) in modalDocuments.box" :key="boxKey" style="width: 100%; padding: 5px 5px"><a href="#" class="modalDocumentCopy" :data-id="document.id" :data-targetBox="box.key">{{box.name}}</a></li>
                                    </ul>
                                  </div>
                                </div>
                                <div class="col-sm-2" v-if="type !== 'preview'">
                                  <button class="btn btn-info btn-outline btn-md modalDocumentSave"  :data-id="document.id"><i class="fa fa-save"></i> Save</button>
                                </div>
                              </div>

                            </div>
                          </div>
                          <div class="well-lg well">
                            <div style="margin-top: 10px" v-for="(document, key) in modalDocuments.documents" :key="key" v-if="( document.type && (document.type === 'patents' || document.type === 'company') && document.cite)"> **{{document.cite}}</div>
                          </div>

                        </div>
                        <div v-else class="text-center">
                          <h2>No Patents in this box</h2>
                        </div>
                      </div>
                      <div id="newsDocsTab" class="tab-pane" :class="{'active' : !modalDocuments.type ||  modalDocuments.type === 'newsDoc'}">
                        <div class="" v-if="nbNewsDoc() !== 0">
                          <div v-for="(document, key) in modalDocuments.documents" :key="key" class="well-lg well" v-if="document.type && ( document.type === 'news')" >
                            <div class="row">
                              <div class="col-sm-12">
                                <label class="col-sm-2">Title</label>
                                <span class="col-sm-10" v-html="document.title"></span>
                              </div>

                              <div class="col-sm-12">
                                <label class="col-sm-2">Source</label>
                                <span class="col-sm-10">{{document.source}} <template v-if="document.dt">,{{document.dt}}</template></span>
                              </div>

                              <div class="col-sm-12" v-if="document.added">
                                <label class="col-sm-2">Added to project</label>
                                <span class="col-sm-10" v-if="document.added && document.added.date">{{document.added.date | moment('ll')}}</span>
                                <span v-else-if="document.added" class="col-sm-10" >{{document.added | moment('ll')}}</span>
                              </div>

                              <div class="col-sm-12">
                                <label class="col-sm-2" style="">Abstract</label>
                                <div style="" class="col-sm-12">
                                  <summernote :id="'editAbstract-' + document.id" style="" v-model="document.abstract" :airMode="false"></summernote>
                                </div>
                              </div>
                              <div class="col-sm-12 text-center" style="margin-top: 15px">
                                <div class="col-sm-3">
                                  <a class="btn btn-info btn-outline btn-md" target="_blank" :href="document.link"><i class="fa fa-eye"></i> View news</a>
                                </div>
                                <div class="col-sm-3" v-if="type !== 'preview'">
                                  <a class="btn btn-info btn-outline btn-md modalDocumentRemove" id="modalDocumentRemove" :data-id="document.id"><i class="fa fa-trash"></i> Remove</a>
                                </div>
                                <div class="col-sm-3" v-if="type !== 'preview'">
                                  <div class="dropup" >
                                    <button class="btn btn-info btn-outline btn-md dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                                      <i class="fa fa-copy"></i>
                                      Copy To
                                      <span class="caret"></span>
                                    </button>
                                    <ul class="dropdown-menu dropdownCopy" aria-labelledby="dropdownCopy" style="min-width: 100%">
                                      <li v-for="(box, boxKey) in modalDocuments.box" :key="boxKey" style="width: 100%; padding: 5px 5px"><a href="#" class="modalDocumentCopy" :data-id="document.id" :data-targetBox="box.key">{{box.name}}</a></li>
                                    </ul>
                                  </div>
                                </div>
                                <div class="col-sm-3" v-if="type !== 'preview'">
                                  <button class="btn btn-info btn-outline btn-md modalDocumentSave" id="modalDocumentSave" :data-id="document.id"><i class="fa fa-save"></i> Save</button>
                                </div>
                              </div>

                            </div>
                          </div>

                        </div>
                        <div v-else class="text-center">
                          <h2>No news in this box</h2>
                        </div>
                      </div>

                      <div id="externalFilesTab" class="tab-pane" :class="{'active' : modalDocuments.type &&  modalDocuments.type === 'externalFile'}">
                        <div class="" v-if="(modal.uploadFiles && modal.uploadFiles.length !== 0)">
                          <div v-for="(file, key) in modal.uploadFiles" :key="key" class="well-lg well" v-if="file.link">
                            <div class="row">
                              <div class="col-sm-12">
                                <label class="col-sm-2">Title</label>
                                <span class="col-sm-10" v-html="file.title"></span>
                              </div>
                              <div class="col-sm-12">
                                <label class="col-sm-2">Authors</label>
                                <span class="col-sm-10">{{file.authors}}</span>
                              </div>
                              <div class="col-sm-12">
                                <label class="col-sm-2" v-if="file.source">Source</label>
                                <span class="col-sm-10">{{file.source}}</span>
                              </div>
                              <div class="col-sm-12" v-if="file.addedAt">
                                <label class="col-sm-2">Added to project</label>
                                <span class="col-sm-3" v-if="file.addedAt"> On {{file.addedAt | moment('ll')}}</span>
                                <span class="col-sm-6" v-if="file.addedBy">
                                  <template v-if="file.addedBy.id === $auth.user().id"> By Me</template>
                                  <template v-else> By {{file.addedBy.firstName}} {{ file.addedBy.lastName}}</template>
                                </span>

                              </div>
                              <div class="col-sm-12 m-b">
                                <label class="col-sm-2" style="">Description</label>
                                <div style="" class="col-sm-10">
                                  <div v-html="file.description"></div>
                                </div>
                              </div>

                              <div class="col-sm-12 text-center" style="margin-top: 15px">
                                <div class="col-sm-3">
                                  <a class="btn btn-info btn-outline btn-md" target="_blank" :href="$apiUrl + file.link"><i class="fa fa-eye"></i> View file</a>
                                </div>
                                <div class="col-sm-3" v-if="type !== 'preview'">
                                  <a class="btn btn-info btn-outline btn-md modalFileRemove" :data-id="key"><i class="fa fa-trash"></i> Remove</a>
                                </div>
                                <div class="col-sm-3" v-if="type !== 'preview'">
                                  <div class="dropup" >
                                    <button class="btn btn-info btn-outline btn-md dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                                      <i class="fa fa-copy"></i>
                                      Copy To
                                      <span class="caret"></span>
                                    </button>
                                    <ul class="dropdown-menu dropdownCopy" aria-labelledby="dropdownCopy" style="min-width: 100%">
                                      <li v-for="(box, boxKey) in modalDocuments.box" :key="boxKey" style="width: 100%; padding: 5px 5px"><a href="#" class="modalFileCopy" :data-id="key" :data-targetBox="box.key">{{box.name}}</a></li>
                                    </ul>
                                  </div>
                                </div>
                                <div class="col-sm-3">
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-else class="text-center">
                          <h2>No attached File in this box</h2>

                        </div>
                        <div class="form-group"  v-bind:class="{'has-error' : modal.errorFiles, 'has-info' : modal.errorFiles === false}">

                          <div class="col-sm-12 m-b-xs m-t">
                            <div class="row text-center">
                              <upload-file  :files="modal.files" :type="'biblio_doc'" :uploadFiles="modal.uploadFiles" :removeFile="removeFile" />
                              <span v-if="modal.errorFiles" class="help-block text-danger">{{ modal.errorFiles }}</span>
                            </div>
                          </div>
                          <div class="col-sm-12 m-b-xs m-t text-right" v-if="nbFileToUpload()">
                            <a class="btn btn-info btn-md uploadExternalFile"><i class="fa fa-upload"></i> Save</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
            </div>
          <div class="modal-footer">
            <button class="btn btn-default" data-dismiss="modal" aria-hidden="true">Close</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="type !== 'preview'" id="modalAddKeyword" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-md">
        <form v-on:submit="addNewKeyword">
          <div class="modal-content">
            <div class="modal-header">
              <h3 v-if="showTexteBiblio === 'default'">Add keyword</h3>
              <h3 v-if="showTexteBiblio === 'boxWithDocument'">Add new box and add document to Box</h3>
              <h3 v-if="showTexteBiblio === 'boxWithComment'">Add new box and add aichat to Box</h3>
            </div>
            <div class="modal-body">
              <div class="rows">
                <div class="form-group">
                  <label v-if="showTexteBiblio === 'default'" for="keyword" class="required">Keyword Name</label>
                  <label v-else for="keyword" class="required">New Box Name</label>
                  <input type="text" id="keyword" class="form-control" v-model="newKeyword" required/>
                </div>

              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-default" data-dismiss="modal" aria-hidden="true">Close</button>
              <vue-ladda v-if="showTexteBiblio === 'default'" type="submit" :loading="submit.loading" class="btn btn-info" :data-style="submit.dataStyle">Add Keyword</vue-ladda>
              <vue-ladda v-if="showTexteBiblio === 'boxWithDocument'" type="submit" :loading="submit.loading" class="btn btn-info" :data-style="submit.dataStyle">Add New Box and document</vue-ladda>
              <vue-ladda v-if="showTexteBiblio === 'boxWithComment'" type="submit" :loading="submit.loading" class="btn btn-info" :data-style="submit.dataStyle">Add New Box and aichat</vue-ladda>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div id="modalExportJson" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <form>
          <div class="modal-content">
            <div class="modal-header">
              <h3>Share Biblio with JSON</h3>
            </div>
            <div class="modal-body">
              <div class="rows">
                <div class="form-group">
                  <label for="exportJson">Json</label>
                  <textarea id="exportJson" class="form-control" v-model="biblioContent" rows="10" onclick="this.focus();this.select()" readonly="readonly"/>
                  <span class="help-block m-b-none">Copy to clipboard: Ctrl+C</span>
                </div>

              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-default" data-dismiss="modal" aria-hidden="true">Close</button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div v-if="type !== 'preview'" id="modalImportJson" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <form v-on:submit="addJson">
          <div class="modal-content">
            <div class="modal-header">
              <h3>Import your Biblio with JSON</h3>
            </div>
            <div class="modal-body">
              <div class="rows">
                <div class="form-group">
                  <label for="importJson" class="required">Json</label>
                  <textarea id="importJson" class="form-control" v-model="importJson" rows="10" required/>
                  <span class="help-block m-b-none">Paste from clipboard: Ctrl+V</span>
                </div>

              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-default" data-dismiss="modal" aria-hidden="true">Close</button>
              <vue-ladda type="submit" :loading="submit.loading" class="btn btn-info" :data-style="submit.dataStyle">Save Json</vue-ladda>
            </div>
          </div>
        </form>
      </div>
    </div>

    <limit-plan ref="limitPlan"></limit-plan>
  </div>
</template>

<style>
  #modalWiki .wiki-thumbnail {
    float: right;
    height: 250px;
  }
</style>
<style scoped>
  #modalWiki img {
    width: 100%;
    padding: 0 35%;
    margin-bottom: 20px;
  }

  .wiki-highlight {
    font-weight: bold;
  }
  #biblioContent.fullScreen {
    display: block;
    z-index: 1002;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    overflow: hidden;
    background-color: white;
    padding: 25px;
  }
  #modalDocuments .dropdownCopy{
    max-height: 370px;
    overflow: hidden;
    overflow-y: scroll;
  }
</style>
<script>

import BiblioGoJs from './BiblioGoJs'
import VueLadda from 'vue-ladda'
import 'trumbowyg/dist/plugins/colors/ui/trumbowyg.colors.min.css'
import 'trumbowyg/dist/plugins/colors/trumbowyg.colors.min'
import Summernote from '../utils/Summernote'
import LimitPlan from '../../components/LimitPlan'
import documentAuthors from './BiblioDocumentAuthors'
import UploadFile from '../question/UploadFile'

export default {
  components: {documentAuthors, Summernote, BiblioGoJs, VueLadda, LimitPlan, UploadFile},
  props: {
    listId: {
      default: null
    },
    project: {
      default: null
    },
    height: {
      default: '400'
    },
    content: {
      default: null
    },
    type: {
      default: null
    }
  },
  name: 'Biblio',
  data () {
    return {
      list: null,
      biblio: null,
      biblioContent: null,
      companyAuthors: null,
      menu: {
        style: {
          display: 'none',
          top: '0',
          left: '0',
          position: 'absolute'
        },
        actions: []
      },
      modal: {
        name: null,
        searchUrl: null,
        color: null,
        comment: null,
        icon: null,
        uploadFiles: [],
        files: [],
        errorFiles: null
      },
      modalWiki: {
        title: null,
        description: null,
        url: null
      },
      modalDocuments: {
        documents: [],
        title: null,
        box: []
      },
      currentNode: null,
      submit: {
        loading: false,
        'dataStyle': 'zoom-in'
      },
      newKeyword: null,
      isFullScreen: false,
      importJson: null,
      document: null,
      showTexteBiblio: 'default',
      aichat: null
    }
  },
  watch: {
    listId: function (val) {
      this.getResources()
    },
    content: function (val) {
      this.biblioContent = val
    }
  },
  computed: {
    modalWikiUrl: function () {
      return this.modalWiki.url.replace(/['"]+/g, '')
    }
  },
  methods: {
    updateBiblioContent: function (val) {
      this.axios.patch('/biblio/' + this.biblio.id, {
        content: val
      }).then((response) => {
        if (response.data && response.data.content) {
          this.biblio.content = response.data.content
        }
        this.$eventHub.$emit('refreshBiblio', true)
        this.$notify({
          type: 'success',
          title: 'Saved to Biblio',
          placement: 'bottom-right'
        })
      })
      this.$emit('updateNbDoc', val)
    },
    getResources: function () {
      if (this.listId !== null && typeof this.listId !== 'undefined') {
        this.axios.get('/list/' + this.listId + '?relations={biblio,companyAuthors}')
          .then((response) => {
            this.list = response.data
            if (response.data.biblio.length !== 0) {
              this.biblio = response.data.biblio[0]
              this.biblioContent = this.biblio.content
              this.companyAuthors = response.data.company_authors
              this.$eventHub.$emit('biblioSelected', this.biblio)
              this.$emit('updateNbDoc', this.biblioContent)
            }
          }).catch(function (error) {
          })
      } else if (this.content !== null) {
        this.biblioContent = this.content
      }
    },
    undo: function () {
      this.$refs.biblio.undo()
    },
    redo: function () {
      this.$refs.biblio.redo()
    },
    // affiliation: function (val) {
    //   if (typeof val !== 'undefined') {
    //     return val.replace(/<b>Affiliation : <\/b>/g, '')
    //   }
    //   return val
    // },
    addNewKeyword: function (e) {
      this.submit.loading = true
      e.preventDefault()
      this.$refs.biblio.addKeyword(this.newKeyword, this.document, this.aichat).then(() => {
        this.submit.loading = false
        $('#modalAddKeyword').modal('hide')
        this.newKeyword = null
        this.document = null
        this.showTexteBiblio = null
      })
    },
    fullScreen: function (e) {
      let biblio = $('#biblioContent')
      let iconFullScreen = $('#iconFullScreen')

      if (biblio.hasClass('fullScreen')) {
        biblio.removeClass('fullScreen')
        iconFullScreen.removeClass('glyphicon-resize-small')
        iconFullScreen.addClass('glyphicon-resize-full')
        $('body').css('overflow', 'initial')
        this.isFullScreen = false
        this.$refs.biblio.diagram.div.style.height = this.height + 'px'
      } else {
        biblio.addClass('fullScreen')
        iconFullScreen.addClass('glyphicon-resize-small')
        iconFullScreen.removeClass('glyphicon-resize-full')
        $('body').css('overflow', 'hidden')
        this.isFullScreen = true
        this.$refs.biblio.diagram.div.style.height = (biblio.height() * 95 / 100) + 'px'
      }
      this.$refs.biblio.diagramResize()
      e.preventDefault()
    },
    resize: function () {
      this.$refs.biblio.diagramResize()
    },
    addJson: function (e) {
      e.preventDefault()
      $('#modalImportJson').modal('hide')
      this.biblioContent = this.importJson
      this.$set(this.biblio, 'content', this.importJson)
      this.$refs.biblio.importJson(this.importJson)
    },
    exportImage: function () {
      if (this.$user.isBasic()) {
        this.$refs.limitPlan.show('biblio')
      } else {
        let blob = this.$refs.biblio.exportImage()

        var a = document.createElement('a')
        document.body.appendChild(a)
        a.style = 'display: none'

        a.href = (window.webkitURL || window.URL).createObjectURL(blob)
        a.download = 'idexlab_biblio.jpeg'
        a.click()

        window.URL.revokeObjectURL(a.href)
      }
    },
    getAllTechnoLockIn: function () {
      if (this.$user.isBasic()) {
        this.$refs.limitPlan.show('biblio')
      } else {
        this.$refs.biblio.getAllTechnoLockIn()
      }
    },
    showModalImportJson: function () {
      if (this.$user.isBasic()) {
        this.$refs.limitPlan.show('biblio')
      } else {
        $('#modalImportJson').modal('show')
      }
    },
    showModalExportJson: function () {
      if (this.$user.isBasic()) {
        this.$refs.limitPlan.show('biblio')
      } else {
        $('#modalExportJson').modal('show')
      }
    },
    showModalAddKeyword: function () {
      if (this.$user.isBasic()) {
        this.$refs.limitPlan.show('biblio')
      } else {
        this.showTexteBiblio = 'default'
        $('#modalAddKeyword').modal('show')
      }
    },
    pdf: function (e) {
      if (this.$user.isBasic()) {
        this.$refs.limitPlan.show('biblio')
      } else {
        this.submit.loading = true
        this.svg = this.$refs.biblio.getSvg()

        this.axios.post('/biblio/' + this.biblio.id + '/project/' + this.project.id + '/pdf/', {img: this.svg}).then((response) => {
          this.$notify({
            type: 'success',
            title: 'Document under preparation',
            content: 'The document is being prepared, an email will be sent to you as soon as it is ready. You can check its status in the export menu.',
            placement: 'bottom-right'
          })
        }).catch((error) => {
          this.$notify({
            type: 'danger',
            title: 'an error has occurred',
            content: 'an error occurred while generating the document, please consult our support',
            placement: 'bottom-right'
          })
        }).finally(() => {
          this.submit.loading = false
        })
      }
    },
    preview: function () {
      window.open('/biblio/' + this.biblio.id + '/preview/' + this.project.id, '_blank')
    },
    history: function () {
      this.$router.push({name: 'BiblioHistory', params: {biblio_id: this.biblio.id}})
    },
    removeFile: function (file) {
      if (typeof file.id !== 'undefined') {
        this.axios.delete('file/biblio/' + file.id).then((response) => {
        }).catch((error) => {

        })
      }
    },
    nbScienceDoc: function () {
      let nb = 0
      if (this.modalDocuments.documents && this.modalDocuments.documents.length) {
        nb = this.modalDocuments.documents.length
        this.modalDocuments.documents.forEach((doc) => {
          if (doc.type && (doc.type === 'patents' || doc.type === 'company' || doc.type === 'news')) nb--
        })
      }
      return nb
    },
    nbPatentDoc: function () {
      let nb = 0
      if (this.modalDocuments.documents && this.modalDocuments.documents.length) {
        this.modalDocuments.documents.forEach((doc) => {
          if (doc.type && (doc.type === 'patents' || doc.type === 'company')) nb++
        })
      }
      return nb
    },
    nbNewsDoc: function () {
      let nb = 0
      if (this.modalDocuments.documents && this.modalDocuments.documents.length) {
        this.modalDocuments.documents.forEach((doc) => {
          if (doc.type && (doc.type === 'news')) nb++
        })
      }
      return nb
    },
    nbFileToUpload: function () {
      let nb = 0
      this.modal.uploadFiles.forEach((file) => {
        if (!file.link) {
          nb++
        }
      })
      return nb
    },
    extractAffiliationName: function (str) {
      let affiliation = JSON.parse(str)
      return affiliation[0] ? affiliation[0].affiliationName ? affiliation[0].affiliationName : null : null
    }
  },
  beforeMount () {
    this.$eventHub.$on('refreshBiblio', () => {
      this.getResources()
    })
    this.$eventHub.$on('addKwdWithDoc', (doc) => { this.document = doc }) // listener
    this.$eventHub.$on('addKwdWithComment', (aichat) => { this.aichat = aichat }) // listener
    this.$eventHub.$on('showTexte', (showTexteBiblio) => { this.showTexteBiblio = showTexteBiblio })
    this.$eventHub.$on('addAiChatCommentToBiblio', (aichat) => { this.$refs.biblio.addAiChatToBiblio(aichat.aichat, aichat.keyId) })

    this.getResources()
  },
  beforeDestroy () {
    this.$eventHub.$off('refreshBiblio')
    this.$eventHub.$off('addKwdWithDoc')
    this.$eventHub.$off('showTexte')
    this.$eventHub.$off('addAiChatCommentToBiblio')
    this.$eventHub.$off('addKwdWithComment')
  },
  mounted () {
    $('[data-toggle="popover"]').popover({
      trigger: 'click hover',
      placement: 'top',
      container: 'body',
      html: true
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/biblio/Biblio.vue